import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class Filter extends BaseComponent {
  constructor(props) {
    super(props);
  }

  onFilterBtnClick(index) {
    let _this = this;
    return function (e) {
      _this.props.onFilterChange(index);
    }
  }

  render() {
    let filterTypes = ["subscribed", "unsubscribed", "function"];
    let filterBtns = filterTypes.map((type, index) => {
      let style = {};
      if (this.props.typeIndex === index) {
        style["color"] = "white";
      } else {
        style["background"] = "white";
      }
      return <a className="waves-effect waves-light btn"
                style={style}
                onClick={this.onFilterBtnClick(index)}
                key={index}>{type}</a>;
    });

    return (
      <div className={styles.filter}>
        {filterBtns}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/search/filter.jsx